export default "__VITE_ASSET__CA$AGNBN6J0p5B2wjLyYdA__"